import { render } from "./LocaleSwitcher.vue?vue&type=template&id=d0f236ca&scoped=true"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=ts"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=ts"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=d0f236ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d0f236ca"

export default script